/*
 * @Author: 陈乾
 * @Date: 2022-03-23 11:27:03
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 09:34:36
 * @Description: file content
 */
import { mapActions, mapGetters } from 'vuex'
const methodMixin = {
  data() {
    return {
      loadingCount: 0
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      $userInfo: 'userInfo'
    })
  },

  watch: {},

  created() {},

  mounted() {},

  methods: {
    ...mapActions('loading', ['commitIsLoading']),
    ...mapActions('common', ['commitUserInfo']),
    $commitUserInfo(userInfo) {
      this.commitUserInfo(userInfo)
    },
    $loading(data, error) {
      // 发送网络请求时，data会传入true，由此计算有几次网络请求
      // data传入为false时表示网络请求成功。
      // 当loadingCount为0时，表示全部请求成功，则关闭全局加载，否则一直开启
      if (data) {
        this.loadingCount++
      } else {
        this.loadingCount--
      }
      // 如果网络请求失败，则loadingCount设为0，关闭全局弹框
      if (error) {
        this.loadingCount = 0
      }
      if (this.loadingCount === 0) {
        this.commitIsLoading(false)
      } else {
        this.commitIsLoading(true)
      }
    }
  }
}

export default methodMixin
